





















































import { AvisDeVirement } from "../../models/AvisDeVirement";
import moment from "moment";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";

export default {
    name: "AvisDeVirementModalEdit",
    components: { ContactSelect, TextareaInput, NumeralInput },
    props: {
        avisDeVirement: AvisDeVirement,
    },
    data() {
        return {
            date: null,
        };
    },
    created() {
        this.initDates();
    },
    methods: {
        initDates() {
            if (this.avisDeVirement.date) {
                this.date = new Date(this.avisDeVirement.date);
            }
        },
        updateDate(date) {
            this.avisDeVirement.date = moment(date).format("YYYY-MM-DD");
        },
    },
    watch: {
        avisDeVirement: {
            immediate: true,
            handler() {
                this.initDates();
            },
        },
    },
};
